import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../App"
import axios from "axios";
import { API_URL } from "../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { ToastContainer, toast } from "react-toastify";
import { handleUserLevelAccessPermissions,changeDateFormat } from "../../../../Custom/Custom";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { generateExcel } from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import messages from '../../../../assets/Messages.json';
import priceTitle from '../../../../price.json';


const PriceAgricultureReport = () => {
  const [years, setYears] = useState([]);
  const [yearName, setYearName] = useState("");
  const [buttonAccess, setButtonAccess] = useState({
    userLevel: "",
    roles: "",
    isVisible: false,
  });

  const token = useContext(MyContextProvider).token;
  const decode_token = jwtDecode(token);
  const navigate = useNavigate();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };


  const storedLanguage = localStorage.getItem('language');

  const getAllYears = () => {
      const currentYear = new Date().getFullYear();
      const yearsArray = [];
      for (let year = currentYear; year >= 2010; year--) {
        yearsArray.push(year);
      }
      return yearsArray;
    };


  useEffect(() => {
    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level);
    setYears(getAllYears());
  }, []);



  const handleDropdownChange = (e) => {
    setYearName(e.target.value);
  };


  
  // handle get Data from Api *******
  const handleGenerateExcel = () => {
    if (!yearName) {
      toast.error("Please select a Survey Year", messages.COLOR_RED);
      return;
    }
    showLoading(true);
     const payload = {
      type: "agri",
      fromYear: yearName,
    };
  
    axios
        .post(`${API_URL}api/price/PriceAgriculturereportAgri`, payload, config)
      .then((response) => {
             const priceAgricultureReport = response.data.data.GroupCodes;
           if (!priceAgricultureReport || priceAgricultureReport.length === 0) {
              toast.error("Data not found", messages.COLOR_RED);
              showLoading(false);
              return;
            }
            downloadReport(priceAgricultureReport,yearName);
          })
        .catch((error) => {
            console.error('API Error:', error);
        }).finally(()=>{
          showLoading(false);

        });
};


const formatGrossValue = (value) => {
  if (value === 0) return "0.00";
  if (value === "NaN" ) return '';
  if (value === '' || value === null) return "0.00";
  return Number(value).toFixed(2);
};


// handle download report ***** 
const downloadReport =(priceAgricultureReport,yearName)=>{
  let redGroup = [''];
  const excelObjectData = {
    fileName: `priceagriculturreport`,
    fileType: 'xls',
    sheetName: "priceagriculturreport",
    firstRowMergeCells: "A1:F1",
    firstRowExportDate: changeDateFormat(new Date()),
    secondRowMergeCells: "A2:F2",
    secondRowText: `PRICE AGRICULTURE REPORT (Base Year 2011-12=100)`,
   headerEnglishColumns: [
      'ITEM TITLE TYPE NAME', 'REAL YEAR', 'REVISED YEAR', 'ITEM TITLE NAME', 'REAL YEAR PRICE', 'REVISED YEAR PRICE'
    ],
    redGroup:redGroup
  };

  const transformedData = priceAgricultureReport.map(item => [
    item.item_title_type_name,
    item.real_year,
    item.revised_year,
    item.item_title_name,
    formatGrossValue(item.real_year_price),
    formatGrossValue(item.revised_year_price),
 ]);

 excelObjectData.excelRowData = transformedData;
 generateExcel(excelObjectData);


}

  return (
    <>
      <GlobalLoading />
      <ToastContainer />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
            <h4 className="page_heading">
              <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.PRICE_AGRICULTURE_REPORT : priceTitle.en.PRICE_AGRICULTURE_REPORT }} />
            </h4>
             <div className="row align-items-center">
                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label className="fw-bold h6">
                  Select Real Year Date
                    </label>
                  <select
                    name="year_name"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={yearName}
                  >
                    <option value="" disabled>
                      Select Year
                    </option>
                    {years &&
                      years.map((ele, index) => (
                        <option key={index} value={ele}>
                          {(ele)}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-xl-2 col-lg-12 mb-3">
                  <label className="w-100 d-none d-sm-block">&nbsp;</label>
                  <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  )
}
export default PriceAgricultureReport